import axios from 'axios';
import { EntityDecisionsParams, EntityDecision } from '../entity.types';

export async function fetchDecisionByEntities(
  params: EntityDecisionsParams,
): Promise<{ decisions: EntityDecision[] }> {
  return (
    await axios.get('/getDecisionByEntities', {
      params,
    })
  ).data;
}
